import CometMarquee from 'comet-marquee';
import 'comet-marquee/dist/comet-marquee.css';

const initializedMarquees = new WeakSet();

window.initTrustpilotMarquee = function initTrustpilotMarquee() {
  const trustpilotMarqueeElsArr = document.querySelectorAll(
    '.trustpilot-reviews-marquee'
  );

  if (trustpilotMarqueeElsArr.length) {
    trustpilotMarqueeElsArr.forEach((marqueeEl, idx) => {
      if (initializedMarquees.has(marqueeEl) || !marqueeEl.querySelector('.comet-marquee-item')) {
        return;
      }
      initializedMarquees.add(marqueeEl);
      marqueeEl.addEventListener('comet-marquee:clones-created', () => {
        marqueeEl.querySelectorAll('.comet-marquee-clone .dir-control[data-dir-init]').forEach((button) => {
          const label = button.querySelector('.dir-control__label');
          if (label) {
            button.innerHTML = label.innerHTML;
            delete button.dataset.dirInit;
          }
        });
        window.dirControlBtnInit?.();
      });
      new CometMarquee(marqueeEl, {
        speed: 30,
        pauseOnHover: true,
        initialShift: window.innerWidth >= 1033,
        pauseOnInvisible: true,
        syncPause: false,
        repeatCount: 5,
        reverse: idx % 2 === 1,
        forceAnimation: window.innerWidth >= 1033,
        forceAnimationWidth: window.innerWidth >= 1033 ? 3 : false,
        fullWidth: window.innerWidth >= 1033,
      });
    });
  }
};

if (!document.querySelector('.bold-loader-new')) {
  initTrustpilotMarquee();
}
